import { PreviewMediaType } from '@/types';

import type { LibraryItem } from '@/types';

export interface PresetShareTarget {
  slug: string;
  title?: string;
  description?: string;
  previewUrl?: string;
  /**
   * Slug of the library section holding the preset — the `<category>` of a
   * gen.ai preset URL (`/<category>/<slug>`), since both are the CMS grid slug.
   * Filled in by `fetchShareLink` from the cached sections, because the callers
   * building a target (the feed, a gallery row) don't all know it: the New tab
   * mixes presets from every section.
   */
  category?: string;
}

/**
 * Narrows a library item to the fields a share link carries.
 *
 * `previewUrl` becomes the link's OG image, so it has to be a still: video
 * presets carry an `.mp4` in `media.url` and unfurlers render no picture for it.
 * Deliberately not passed through `optimizeImageUrl` either — that forces
 * `type=webp`, which WhatsApp in particular fails to preview.
 */
const toShareTarget = (item: LibraryItem): PresetShareTarget => ({
  slug: item.slug,
  title: item.title,
  description: item.description,
  previewUrl:
    item.type === PreviewMediaType.VIDEO ? item.media.poster : item.media.url,
});

export default toShareTarget;
